import React from 'react';
import PropTypes from 'prop-types';

import { ExternalLink } from 'core/routing';

import {
  SocialLinks,
  SocialItem,
  IconStyled,
} from 'apps/components/footer/footer.styled';

import { conf } from 'apps/components/footer/config.yaml';
import theme from 'styles/themes/wikifactory';

const socialLinks = Array.from(conf.social.entries());

const Social = props => (
  <SocialLinks>
    {socialLinks.map(([index, item]) => (
      <SocialItem key={index} hideText={props.hideText}>
        <ExternalLink name={item.link} to={item.link}>
          <IconStyled
            name={item.icon}
            size='medium'
            colorPath={props.grey ? theme.color.wfGrey600 : theme.color.wfWhite}
          />
          {!props.hideText && <strong>{item.text}</strong>}
        </ExternalLink>
      </SocialItem>
    ))}
  </SocialLinks>
);

Social.propTypes = {
  grey: PropTypes.bool,
  hideText: PropTypes.bool,
};

export default Social;
